import React, { Component } from 'react';

//APPOLO + GQL
import { ApolloProvider, Query } from "react-apollo";
import { queryGetTickets } from "../../queries/querySettings";

//OFFICE Fabric
import { Customizer, getId } from '@uifabric/utilities';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { PivotItem, Pivot } from 'office-ui-fabric-react/lib/Pivot';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';

//Styles

import './Setter.scss';
import TicketList from "./UserList/TicketList";
import { ToastContainer } from "react-toastify";
import AddTicket from "./UserList/AddTicket";
import { MyContext } from '../../context';


export default class SetterTicket extends Component {
    state = {
        showPanel: false,
        trapPanel: false,
        filter: this.props.userRules?.ticketFilter ? {
            cycle: this.props.userRules.ticketFilter.cycle || "",
            startDate: this.props.userRules.ticketFilter.startDate || null,
            endDate: this.props.userRules.ticketFilter.endDate || null,
            grabClosedTickets: this.props.userRules.ticketFilter.grabClosedTickets || false,
            state: this.props.userRules.ticketFilter.state || [],
        } : null,
        withSave: false,
    };
    _layerHostId: string = getId('layerHost');

    handleSearch = (filter, withSave) => {
        this.setState({ filter, withSave });
    };

    // This is based on the definition of items
    render() {
        return (
            <div>
                <div className={window.location.pathname.includes("main") ? "setter-content-main" : "setter-content"}>
                    <div className="ms-Grid">

                        <div className="ms-Grid-row">

                            <div>
                                <Customizer
                                    scopedSettings={
                                        this.state.trapPanel
                                            ? {
                                                Layer: {
                                                    hostId: this._layerHostId
                                                }
                                            }
                                            : {}
                                    }
                                >
                                    {this.state.showPanel && (
                                        <Panel
                                            type={PanelType.medium}
                                            isOpen={true}
                                            hasCloseButton={true}
                                            headerText={this.configurationTextSelect()}
                                            focusTrapZoneProps={{
                                                isClickableOutsideFocusTrap: true,
                                                forceFocusInsideTrap: false
                                            }}
                                            onDismiss={this._onDismissPanel}>
                                            {this.panelSelect()}
                                        </Panel>
                                    )}
                                </Customizer>

                            </div>


                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" >
                                <ApolloProvider client={this.props.apol}>
                                    {this.query(this._show, this.props.authorization, this.props.apol, null, true, this.props.userRules, this.state.filter, this.state.withSave)}

                                </ApolloProvider>

                            </div>
                        </div>
                    </div>

                </div>
                <ToastContainer />

            </div>
        )
    }

    _onDismissPanel = (): void => {
        this.setState({
            showPanel: false
        });
    };

    rules = [];

    _show = (current, vall) => {
        switch (vall) {
            case undefined:
            case null:
                break;
            default:


                if (current == null) {
                    this.setState({ showPanel: true, case: vall, info: null });
                }
                else {
                    this.setState({ showPanel: true, case: vall, info: current });
                }


        }
    }

    query = (layerFunction, auth, apol, tenantId, asPartner, userRules, filter, withSave) => {
        return <MyContext.Consumer>
            {(context) => (
                <Query
                    query={queryGetTickets}
                    variables={{ auth, tenantId, asPartner, filter, withSave }} >
                    {({ loading, error, data }) => {
                        if (loading) return <div>
                            <Spinner label={context.getTranslation("common", "stillLoading")} ariaLive="assertive" labelPosition="top" />
                        </div>;
                        if (error) return <h1> </h1>;

                        if (data.getTickets == null) {
                            return <div> </div>;
                        }
                        this.tenants = data.getTickets;
                        return <Pivot>
                            { }
                            <PivotItem key="01" linkText="Ticket Administration" itemCount={data.getTickets != null ? data.getTickets.length : 0} itemIcon="PlayerSettings">
                                <TicketList
                                    key="01"
                                    icon={"PlayerSettings"}
                                    data={data.getTickets}
                                    func={layerFunction}
                                    close={this._onDismissPanel}
                                    authorization={auth}
                                    apol={apol}
                                    userRules={userRules}
                                    searchFunction={this.handleSearch}
                                    filter={this.state.filter}
                                    withSave={this.state.withSave}
                                />
                            </PivotItem>
                        </Pivot>
                    }
                    }
                </Query>
            )
            }
        </MyContext.Consumer>
    }

    configurationTextSelect() {
        switch (this.state.case) {
            case 0: return "Update Ticket"
            case 1: return "Add Ticket"
            default: return ""
        }
    }

    panelSelect() {
        switch (this.state.case) {
            case 0: return <AddTicket data={this.state.info} cl={this._onDismissPanel} authorization={this.props.authorization} apol={this.props.apol} userRules={this.props.userRules} />
            case 1: return <AddTicket cl={this._onDismissPanel} authorization={this.props.authorization} apol={this.props.apol} userRules={this.props.userRules} />
            default: return <div> </div>
        }
    }

}
